export default (url: string) => url.replace(/(\/[a-z]{2})($|\/)/, '/');
